/**
 * @fileoverview Workspace Pre-Appointment Custom Fields
 *
 * URL: /dashboard/pre-appointment-fields
 *
 * Firm-defined attributes tracked against pre-appointment jobs — a fee
 * estimate, an expected appointment date — with the colour and icon their
 * value badges wear on the pipeline board, list and referrer card. Sits
 * beside Stages and Labels under the workspace Pipeline section.
 *
 * - Convex: preAppointment.fields.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { PreAppointmentFieldsManager } from "@/components/settings/pre-appointment/PreAppointmentFieldsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/pre-appointment-fields",
)({
  component: PreAppointmentFieldsPage,
});

function PreAppointmentFieldsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <PreAppointmentFieldsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage custom fields.
        </div>
      )}
    </div>
  );
}
